"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Functions = void 0;
const date_fns_1 = require("date-fns");
const trimToEllipsis = (longString, maxStrLength, ellipsisPosition) => {
    const length = longString.length;
    if (length > maxStrLength) {
        if (maxStrLength === 0) {
            return '';
        }
        if (maxStrLength === 1) {
            return '.';
        }
        if (maxStrLength === 2) {
            return '..';
        }
        const numberOfLettersToKeep = maxStrLength - 3;
        if (ellipsisPosition === 'end') {
            return longString.substr(0, numberOfLettersToKeep) + '...';
        }
        else {
            const isOdd = numberOfLettersToKeep % 2 === 1;
            const numberOfLettersFromStart = Math.floor(numberOfLettersToKeep / 2) + (isOdd ? 1 : 0);
            const numberOfLettersFromEnd = Math.floor(numberOfLettersToKeep / 2);
            const startFragment = longString.substr(0, numberOfLettersFromStart);
            const endFragment = longString.substr(length - numberOfLettersFromEnd, numberOfLettersFromEnd);
            return `${startFragment}...${endFragment}`;
        }
    }
    else {
        return longString;
    }
};
const removePunctuation = (str) => {
    const NON_ALPHANUMERIC_CHARACTERS = /[^\w\s]|_/g;
    const WHITESPACE_CHARACTERS = /\s+/g;
    return str.replace(NON_ALPHANUMERIC_CHARACTERS, '').replace(WHITESPACE_CHARACTERS, '');
};
const isSubstringFuzzy = (outer, inner) => {
    const outerLowercase = outer.toLowerCase();
    const innerLowercase = inner.toLowerCase();
    const outerLowercaseNoPunctuation = removePunctuation(outerLowercase);
    const innerLowercaseNoPunctuation = removePunctuation(innerLowercase);
    return outerLowercaseNoPunctuation.indexOf(innerLowercaseNoPunctuation) !== -1;
};
const updateArray = (oldArray, idOfElementToUpdate, propName, newValue) => {
    const newArray = [];
    oldArray.forEach(element => {
        const newElement = {
            ...element,
        };
        if (newElement.id === idOfElementToUpdate) {
            newElement[propName] = newValue;
        }
        newArray.push(newElement);
    });
    return newArray;
};
const iso8601DateStringToUserFriendlyStringOrPlaceholder = (isoDateString) => {
    return isoDateString ? (0, date_fns_1.format)(new Date(isoDateString), 'MMM dd, yyyy') : '--';
};
const iso8601DateString = () => {
    return new Date().toISOString();
};
const downloadFile = (data, filename) => {
    const url = URL.createObjectURL(data instanceof Blob ? data : new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    if (link.parentElement) {
        link.parentElement.removeChild(link);
    }
};
const humanFileSize = (bytes, decimalPlaces = 1) => {
    const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const threshold = 1000;
    if (Math.abs(bytes) < threshold) {
        return bytes + ' B';
    }
    let u = -1;
    const r = 10 ** decimalPlaces;
    do {
        bytes /= threshold;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= threshold && u < units.length - 1);
    return bytes.toFixed(decimalPlaces) + ' ' + units[u];
};
exports.Functions = {
    trimToEllipsis,
    isSubstringFuzzy,
    updateArray,
    iso8601DateString,
    iso8601DateStringToUserFriendlyStringOrPlaceholder,
    downloadFile,
    humanFileSize,
};
